/* NOMO 06-10 product page update.
   1. "Betaal later met Klarna" under the headline (only when Klarna is active in Shopify Payments).
   2. Under the buy button: three checks (texts: theme editor > Teksten productpagina > Vinkjes onder de koopknop),
      then the payment logos, centred. Shopify's own iDEAL logo is added when it is not listed.
   3. Review score (from the reviews section) as a small star line at the top of the product info (plain text, no link).
   4. The "Linda en 30.000+ anderen kochten" line moves to the photo section "Zo draag je NOMO.".
   5. Bundle "Duo" (2 bags) is pre-selected; no colour looks chosen until the shopper taps one. The label next to
      "Tas 1" says "Kies een kleur" until then, and the buy button asks for the colour first. (The theme always keeps
      a colour in the background; this only changes what the shopper sees and when they can buy.)
      After a colour is chosen, the label shows only the colour (no size, no "+€5").
   6. Performance: "Zie het in actie" clips never load or play by themselves; they load on tap only, muted, with a
      play/pause button. The hidden gallery video no longer downloads on page load.
   7. Safety net for the scroll fade-ins: a block that is on screen is always shown, even if the page was busy.
   8. Reviews: photo lightbox, "Meer reviews tonen" (desktop), swipe hint (mobile) and the product chip under each
      review: a tap picks that colour for the first bag that has no colour yet (or bag 1) and scrolls up to it. */
(function () {
  var T = {};
  try { T = JSON.parse((document.getElementById('nomo-hero-texts') || {}).textContent || '{}') || {}; } catch (e) { T = {}; }
  var clean = function (s) { return String(s == null ? '' : s).replace(/[<>&"]/g, ''); };
  var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.4l3.1 3.1L13 4.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 2.4l2.3 4.8 5.2.7-3.8 3.6.9 5.2L10 14.2l-4.6 2.5.9-5.2-3.8-3.6 5.2-.7z"/></svg>';
  var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>';
  var PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" fill="currentColor"/></svg>';
  var CHOOSE = 'Kies een kleur';
  var nativePlay = HTMLMediaElement.prototype.play;

  // Keeps a video from loading or starting unless we allow it (theme.js keeps calling play()/preload='auto').
  var gate = function (v) {
    if (v.__nbGate) return v.__nbGate;
    var state = { allow: false };
    v.__nbGate = state;
    try {
      v.play = function () { return state.allow ? nativePlay.call(v) : Promise.resolve(); };
      Object.defineProperty(v, 'preload', {
        configurable: true,
        get: function () { return v.getAttribute('preload') || 'none'; },
        set: function (val) { if (state.allow || val === 'none' || val === 'metadata') v.setAttribute('preload', val); }
      });
    } catch (e) {}
    return state;
  };

  var buildChecks = function () {
    document.querySelectorAll('nomo-product').forEach(function (product) {
      var atc = product.querySelector('.nb-atc');
      if (!atc || product.querySelector('.nb-checks')) return;
      var checks = String(T.atcBadges || '30 dagen retour | Gratis verzending | 10.000+ tevreden klanten').split('|')
        .map(function (t) { return t.trim(); }).filter(Boolean).slice(0, 3);
      var list = document.createElement('ul');
      list.className = 'nb-checks';
      list.setAttribute('role', 'list');
      list.innerHTML = checks.map(function (t) { return '<li>' + CHECK + '<span>' + clean(t) + '</span></li>'; }).join('');
      atc.insertAdjacentElement('afterend', list);
      var pay = product.querySelector('.nomo-payment-methods');
      if (pay) {
        var tpl = document.getElementById('nomo-ideal-svg');
        var hasIdeal = [].some.call(pay.querySelectorAll('svg'), function (s) { return /ideal/i.test((s.getAttribute('aria-labelledby') || '') + (s.getAttribute('aria-label') || '') + ((s.querySelector('title') || {}).textContent || '')); });
        if (!hasIdeal && tpl) pay.insertBefore(tpl.content.cloneNode(true), pay.firstChild);
        list.insertAdjacentElement('afterend', pay);
      }
    });
  };

  var buildKlarna = function () {
    var pay = document.querySelector('.nomo-payment-methods');
    var active = T.klarnaOn === true || (pay && /klarna/i.test(pay.innerHTML));
    var text = (T.klarnaText == null ? 'Shop nu, betaal later met Klarna' : String(T.klarnaText)).trim();
    if (!active || !text) return;
    document.querySelectorAll('nomo-product .nb-hero-box').forEach(function (box) {
      if (box.parentElement.querySelector('.nb-klarna')) return;
      var p = document.createElement('p');
      p.className = 'nb-klarna';
      p.innerHTML = '<span class="nb-klarna__logo" aria-hidden="true">Klarna.</span><span>' + clean(text) + '</span>';
      box.insertAdjacentElement('afterend', p);
    });
  };

  var buildRating = function () {
    var num = document.querySelector('.nbr__num');
    var score = num ? num.textContent.trim() : '';
    if (!score) return;
    var sec = document.querySelector('.nbr');
    var total = sec && sec.dataset ? sec.dataset.total : '';
    document.querySelectorAll('nomo-product').forEach(function (product) {
      if (product.querySelector('.nb-rating')) return;
      var a = document.createElement('p');
      a.className = 'nb-rating';
      a.setAttribute('aria-label', score + ' van 5 sterren' + (total ? ', ' + total + ' reviews' : ''));
      a.innerHTML = '<span class="nb-rating__stars" aria-hidden="true">' + STAR + STAR + STAR + STAR + STAR + '</span><b>' + clean(score) + '</b><span class="nb-rating__of">/5</span>' + (total ? '<span class="nb-rating__txt" style="text-decoration:none">· ' + clean(total) + ' reviews</span>' : '');
      var anchor = product.querySelector('.nomo-proof') || product.querySelector('.nomo-smooth-name');
      if (anchor) anchor.insertAdjacentElement('beforebegin', a); else product.insertAdjacentElement('afterbegin', a);
    });
  };

  var moveProof = function () {
    var proof = document.querySelector('nomo-product .nomo-proof');
    var head = document.querySelector('.nomo-community__head');
    if (!proof || !head) return;
    var kicker = head.querySelector('.section-kicker');
    proof.classList.add('nomo-proof--gallery');
    if (kicker) kicker.replaceWith(proof);
    else { var title = head.querySelector('.section-title'); if (title) title.insertAdjacentElement('beforebegin', proof); }
  };

  // Label next to "Jouw tas / Tas 1": "Kies een kleur" until a colour is tapped, then only the colour.
  var colourOnly = function () {
    document.querySelectorAll('[data-pick-selection]').forEach(function (el) {
      var trim = function () {
        var pick = el.closest('.nb-pick');
        var want;
        if (pick && pick.classList.contains('nb-unpicked')) want = CHOOSE;
        else {
          var checked = pick && pick.querySelector('[data-pick-color]:checked');
          want = checked ? checked.value : (el.textContent.split('·')[1] || el.textContent).trim();
        }
        if (want && el.textContent !== want) el.textContent = want;
      };
      trim();
      if (el.dataset.nbColourOnly) return;
      el.dataset.nbColourOnly = '1';
      new MutationObserver(trim).observe(el, { childList: true, characterData: true, subtree: true });
    });
  };

  var touchPick = function (pick) {
    pick.dataset.nbTouched = '1';
    pick.classList.remove('nb-unpicked');
    var err = pick.querySelector('.nb-pick-error'); if (err) err.remove();
    setTimeout(colourOnly, 0);
  };

  // Duo pre-selected, and no colour shown as chosen until the shopper picks one.
  var picker = function () {
    var mark = function () {
      document.querySelectorAll('.nb-pick').forEach(function (pick) {
        if (!pick.dataset.nbTouched) pick.classList.add('nb-unpicked');
      });
      colourOnly();
    };
    var duo = document.querySelector('nomo-product [data-quantity-choice][value="2"]');
    if (duo && !duo.checked) duo.click();
    mark();
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-quantity-choice]')) setTimeout(mark, 0);
    });
    var touch = function (e) {
      var input = e.target.closest && (e.target.closest('.nb-sw label') || e.target.closest('[data-pick-color]'));
      if (!input) return;
      var pick = input.closest('.nb-pick');
      if (pick) touchPick(pick);
    };
    document.addEventListener('click', touch, true);
    document.addEventListener('keydown', function (e) { if (/Arrow|Space|Enter| /.test(e.key) && e.target.matches && e.target.matches('[data-pick-color]')) touch(e); }, true);
    // Buy button: ask for the missing colour first.
    var guard = function (e) {
      var form = e.target.closest && (e.target.closest('.nb-atc') ? e.target.closest('form') : (e.type === 'submit' ? e.target : null));
      if (!form || !form.querySelector('.nb-pick')) return;
      var open = [].filter.call(form.querySelectorAll('.nb-pick.nb-unpicked'), function (p) { return !p.hidden; });
      if (!open.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      open.forEach(function (p) {
        if (!p.querySelector('.nb-pick-error')) { var m = document.createElement('p'); m.className = 'nb-pick-error'; m.setAttribute('role', 'alert'); m.textContent = CHOOSE + ' voor deze tas'; p.appendChild(m); }
      });
      var first = open[0];
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      first.classList.remove('is-nudge'); void first.offsetWidth; first.classList.add('is-nudge');
    };
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);
  };

  // Product chip under a review: pick that colour for the first bag without a colour (or bag 1).
  var chooseColour = function (colour) {
    var picks = [].filter.call(document.querySelectorAll('nomo-product .nb-pick'), function (p) { return !p.hidden; });
    if (!picks.length) return;
    var pick = picks.filter(function (p) { return p.classList.contains('nb-unpicked'); })[0] || picks[0];
    var want = String(colour || '').trim().toLowerCase();
    var find = function () { return [].filter.call(pick.querySelectorAll('[data-pick-color]'), function (i) { return i.value.trim().toLowerCase() === want; })[0]; };
    var input = find();
    if (input && input.disabled) {
      var small = pick.querySelector('[data-pick-size][value="Small"]');
      if (small && !small.checked) { (small.closest('label') || small).click(); input = find(); }
    }
    pick.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (!input || input.disabled) return;
    (input.closest('label') || input).click();
    touchPick(pick);
    pick.classList.remove('is-nudge'); void pick.offsetWidth; pick.classList.add('is-nudge');
  };

  var reviewRail = function () {
    var track = document.querySelector('.nbr__cards');
    if (!track || track.dataset.nbMeta) return;
    track.dataset.nbMeta = '1';
    var meta = document.createElement('div');
    meta.className = 'nb-rail-meta';
    meta.innerHTML = '<span class="nb-rail-meta__hint" aria-hidden="true">' + clean(T.swipeHint || 'Swipe voor meer') + ' <svg viewBox="0 0 24 24"><path d="M5 12h13M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="nb-rail-meta__bar" aria-hidden="true"><i></i></span>';
    track.insertAdjacentElement('afterend', meta);
    var bar = meta.querySelector('i');
    var sync = function () {
      var over = track.scrollWidth > track.clientWidth + 4;
      meta.hidden = !over;
      if (!over) return;
      var n = track.children.length || 1;
      var max = Math.max(1, track.scrollWidth - track.clientWidth);
      bar.style.width = Math.max(100 / n, Math.min(1, track.scrollLeft / max) * 100) + '%';
      meta.classList.toggle('is-moved', track.scrollLeft > 8);
    };
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    sync();
  };

  var clips = function () {
    document.querySelectorAll('.nb-clip').forEach(function (fig) {
      var v = fig.querySelector('video');
      if (!v || fig.dataset.nbPlay) return;
      fig.dataset.nbPlay = '1';
      var g = gate(v);
      v.removeAttribute('controls');
      v.removeAttribute('autoplay');
      v.controls = false;
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('preload', 'none');
      if (!v.paused) v.pause();
      v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nb-clip__play';
      btn.setAttribute('aria-label', 'Video afspelen');
      btn.innerHTML = PLAY;
      fig.appendChild(btn);
      var sync = function () {
        var playing = !v.paused && !v.ended;
        fig.classList.toggle('is-playing', playing);
        btn.innerHTML = playing ? PAUSE : PLAY;
        btn.setAttribute('aria-label', playing ? 'Video pauzeren' : 'Video afspelen');
      };
      v.addEventListener('play', sync);
      v.addEventListener('pause', sync);
      v.addEventListener('ended', sync);
      var toggle = function (e) {
        e.preventDefault(); e.stopPropagation();
        if (v.paused || v.ended) {
          document.querySelectorAll('.nb-clip video').forEach(function (o) { if (o !== v && !o.paused) { if (o.__nbGate) o.__nbGate.allow = false; o.pause(); } });
          g.allow = true; v.muted = true;
          var p = nativePlay.call(v); if (p && p.catch) p.catch(function () {});
        } else { g.allow = false; v.pause(); }
      };
      btn.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      v.addEventListener('pause', function () { g.allow = false; });
      sync();
    });
  };

  var galleryVideo = function () {
    document.querySelectorAll('.gallery-item--video video').forEach(function (v) {
      var item = v.closest('.gallery-item');
      if (!item || !item.hidden) return;
      v.removeAttribute('autoplay');
      v.autoplay = false;
      v.setAttribute('preload', 'none');
      if (!v.paused) v.pause();
    });
  };

  var revealNet = function () {
    var show = function () {
      var h = window.innerHeight || 800;
      document.querySelectorAll('.nb-rise:not(.is-in), .nb-unveil:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < h && r.bottom > 0) el.classList.add('is-in');
      });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -5% 0px' });
      setTimeout(function () { document.querySelectorAll('.nb-rise:not(.is-in), .nb-unveil:not(.is-in)').forEach(function (el) { io.observe(el); }); }, 300);
    }
    window.addEventListener('load', show);
    window.addEventListener('hashchange', function () { setTimeout(show, 120); });
    setInterval(show, 1500);
  };

  var reviews = function () {
    reviewRail();
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-nbr-colour]');
      if (chip) { e.preventDefault(); chooseColour(chip.dataset.nbrColour); return; }
      var photo = e.target.closest('[data-nbr-photo]');
      if (photo) {
        var lb = photo.closest('.nbr') && photo.closest('.nbr').querySelector('[data-nbr-lb]');
        var img = lb && lb.querySelector('[data-nbr-lb-img]');
        if (!lb || !img || typeof lb.showModal !== 'function') return;
        img.src = photo.dataset.full;
        img.alt = photo.dataset.alt || '';
        lb.showModal();
        return;
      }
      var more = e.target.closest('[data-nbr-more]');
      if (more) {
        var cards = more.closest('.nbr') && more.closest('.nbr').querySelector('[data-nbr-cards]');
        if (cards) cards.removeAttribute('data-collapsed');
        more.remove();
        return;
      }
      var dlg = e.target.closest('[data-nbr-lb]');
      if (dlg && (e.target === dlg || e.target.closest('[data-nbr-close]'))) dlg.close();
    });
  };

  var run = function () {
    clips(); galleryVideo();
    buildKlarna(); buildChecks(); buildRating(); moveProof(); picker(); reviews(); revealNet();
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.nb-pick')) setTimeout(colourOnly, 0); });
    window.addEventListener('load', function () { colourOnly(); galleryVideo(); document.querySelectorAll('.nb-clip video').forEach(function (v) { v.removeAttribute('controls'); v.controls = false; v.muted = true; }); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
